import React, { useEffect, useState } from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import TutorFooter from '../TutorFooter/TutorFooter'
import { Link } from 'react-router-dom'
import TutorHeader from '../TutorHeader/TutorHeader'
import { getTutorMyEarningsData } from '../../../Redux/action/TutorAction'
import { useDispatch, useSelector } from 'react-redux'
import Beatloader from '../../../Common/BeatLoader'
import { useFormik } from 'formik'

const TutorMyEarnings = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getTutorMyEarningsData('', ''));
    }, []);



    const {

        loadingTutorMyEarningDataApi,
        TutorMyEarningDataApiData,
        TutorMyEarningDataApiError

    } = useSelector(state => state?.TutorReducer);


    let [initialValues, setInitialValues] = useState({
        start_date: "",
        end_date: "",

    })

    const formik = useFormik({
        initialValues: initialValues,

        onSubmit: async (values, { setSubmitting, resetForm }) => {
            console.log(values)

            dispatch(getTutorMyEarningsData(values.start_date, values.end_date));


        }
    });

    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Earnings
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            {loadingTutorMyEarningDataApi ?
                                <Beatloader />
                                :
                                <main className="px-3 py-4">
                                    <div className="my-earning-sec">
                                        <form onSubmit={formik.handleSubmit} >
                                            <div className="row mb-3">
                                                <div className="col-lg-4 col-md-4">
                                                    <label htmlFor="" className="fw-bold">
                                                        Start Date
                                                    </label>
                                                    <br />
                                                    <input type="date" className="input-card-form"
                                                        max={new Date().toISOString().split("T")[0]}
                                                        name='start_date'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.start_date}
                                                    />
                                                </div>
                                                <div className="col-lg-4 col-md-4">
                                                    <label htmlFor="" className="fw-bold">
                                                        End Date
                                                    </label>
                                                    <br />
                                                    <input type="date" className="input-card-form"
                                                        max={new Date().toISOString().split("T")[0]}
                                                        min={formik.values.start_date}
                                                        name='end_date'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.end_date}
                                                    />
                                                </div>
                                                <div className="col-lg-3 col-md-3">
                                                    <button type='submit' className="btn btn-primary w-100 submit-btn w-100">
                                                        Submit
                                                    </button>
                                                </div>

                                            </div>
                                        </form>
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6 mb-3">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="bi bi-calendar-check-fill" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 text-white">Total No. Session</h5>
                                                                <p className="mb-0 text-white fw-bold">{TutorMyEarningDataApiData?.total_no_of_Session}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 mb-3">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="fa-solid fa-sack-dollar" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 text-white">Total Earnings</h5>
                                                                <p className="mb-0 text-white fw-bold">${TutorMyEarningDataApiData?.totalEarning}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table my-4 table-striped">
                                                <thead className="bg-primary" style={{ color: "#fff" }}>
                                                    <tr>
                                                        <th scope="col" className="text-center">
                                                            Date
                                                        </th>
                                                        <th scope="col" className="text-center">
                                                            No. of Sessions
                                                        </th>
                                                        <th scope="col" className="text-center">
                                                            Price per Sessions
                                                        </th>
                                                        <th scope="col" className="text-center">
                                                            Total
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {TutorMyEarningDataApiData?.data?.map((data) => (
                                                        <tr>
                                                            <th scope="row" className="text-center">
                                                                {new Date(data?.createdAt).toISOString().split('T')[0]}
                                                            </th>
                                                            <td className="fw-bold text-center">{data?.no_of_session}</td>
                                                            <td className="fw-bold text-center">{data?.per_session_price}</td>
                                                            <td className="fw-bold text-center">${data?.amount}</td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </main>}

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorMyEarnings